export const getTestIds = (index: number) => ({
  company: `message-wrapper_company_${index}`,
  wrapper: `message-wrapper_${index}`,
});
